import {ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ClientDetailsService} from '../client-details/client-details.service';
import {ClientInformationViewModel} from './view-models/client-information-view.model';
import {ClientInformationConverterService} from './view-models/client-information-converter.service';
import {AppParameterMap} from '../../config/app-parameter-map';
import {PARAM_ENTITY_ID} from '../../config/app-urls';
import {Router} from '@angular/router';
import {LoadingAnimationComponent} from '@shared/components/loading-animation/loading-animation.component';
import {ClientInformationRowDirective} from './directives/client-information-row.directive';

@Component({
    selector: 'app-client-information',
    templateUrl: './client-information.component.html',
    styleUrls: ['./client-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingAnimationComponent, ClientInformationRowDirective]
})
export class ClientInformationComponent implements OnInit {

  private readonly _router = inject(Router);
  private readonly _clientDetailsService = inject(ClientDetailsService);
  private readonly _converterService = inject(ClientInformationConverterService);
  private readonly _destroyRef = inject(DestroyRef);

  readonly dataLoading = signal(true);
  readonly clientInformation = signal<ClientInformationViewModel | null>(null);

  ngOnInit() {
    this.dataLoading.set(true);

    const params = AppParameterMap.from(this._router);
    const entityId = params.get(PARAM_ENTITY_ID);

    this.getClientInformation(entityId);
  }

  getClientInformation(clientCode: string) {
    this._clientDetailsService.getClientDetails(clientCode).pipe(
      takeUntilDestroyed(this._destroyRef)
    ).subscribe(clientInformation => {
      this.clientInformation.set(this._converterService.convert(clientInformation));
      this.dataLoading.set(false);
    });
  }
}
